import React, { createContext, useRef, useContext } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch } from 'react-redux';
import { setRecaptchaToken } from '../actions/users/recaptchaToken';

const ReCaptchaContext = createContext(null);

export const ReCaptchaProvider = ({ children }) => {
  const recaptchaRef = useRef(null);
  const dispatch = useDispatch();

  const resetRecaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  const getToken = async () => {
    if (window.IS_RUNNING_IN_CYPRESS) {
      return '1234';
    }

    if (recaptchaRef.current) {
      resetRecaptcha();
      return await recaptchaRef.current.executeAsync();
    }

    throw new Error('reCAPTCHA no está inicializado.');
  };

  const saveTokenInState = async () => {
    if (window.IS_RUNNING_IN_CYPRESS) {
      return '1234';
    }

    if (recaptchaRef.current) {
      resetRecaptcha();
      const recaptchaToken = await recaptchaRef.current.executeAsync();
      return dispatch(setRecaptchaToken(recaptchaToken));
    }

    throw new Error('reCAPTCHA no está inicializado.');
  };

  return (
    <ReCaptchaContext.Provider value={{ getToken, saveTokenInState, resetRecaptcha }}>
      {children}
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={window.REACT_APP_GOOGLE_RECAPTCHA_V2_KEY}
        size='invisible'
      />
    </ReCaptchaContext.Provider>
  );
};

export const useReCaptcha = () => useContext(ReCaptchaContext);
